<p-confirmDialog key="import" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="GridMenu">
	<!--Instructions-->
	<label>Import Format:</label>
	<span style="font-size: 12px">Driver License Number, Driver's Name (optional, you can add it to all, some, or none of the entries)</span>

	<label>Format:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="FormatOption" [(ngModel)]="FormatOption">
		<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
			{{ o.Desc }}
		</option>
	</select>

	<label>File to Import:</label>
	<div class="FilePickerMenu">
		<label class="InfoText">{{ ImportFile?.name }}</label>
		<button class="btn btn-primary" (click)="onSelectFile()">Select File</button>
	</div>

	<label>Deactivate drivers that are not on the list</label>

	<div class="CenterDiv">
		<input class="form-control CHK" type="checkbox" [(ngModel)]="Deactivate" />
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<input id="ImportInput" name="ImportInput" type="file" style="display: none" (change)="onFileToImportChange($event)" />

	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onImport()">Import</button>
	<button [disabled]="IsProcessing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
